import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Trip } from '@returnmates/client-core/src/graphql/generated/api'
import { memo } from 'react'
import { FieldArray } from 'react-final-form-arrays'

import useStyles from '../styles'
import TrackingRow from './TrackingRow'

interface Props {
  currentTrip: Trip | null
}

const StatusHistory = ({ currentTrip }: Props) => {
  const classes = useStyles()

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.headerRow}>
          <TableCell className={classes.headerCell}>Date</TableCell>
          <TableCell className={classes.headerCell}>Status</TableCell>
          <TableCell className={classes.headerCell}>Source</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <FieldArray name="tracking">
          {({ fields }) =>
            fields.map((fieldName, i) => {
              if (
                (i === Number(currentTrip?.tracking.length) - 1 &&
                  !currentTrip?.tracking[Number(currentTrip?.tracking.length) - 1]?.status) ||
                (i === Number(currentTrip?.tracking.length) - 2 &&
                  !currentTrip?.tracking[Number(currentTrip?.tracking.length) - 2]?.status)
              ) {
                return null
              } else {
                return (
                  <TrackingRow
                    tracking={currentTrip?.tracking}
                    fieldName={fieldName}
                    key={fieldName}
                  />
                )
              }
            })
          }
        </FieldArray>
      </TableBody>
    </Table>
  )
}

export default memo(StatusHistory)
